const initState = {
    isLoading: false,
    data: [],
    error: null,
}

export default function ProductListReducer(state = initState, action) {
    switch (action.type) {
        case "SET_PRODUCT_LIST_LOADING":
            return {
                ...state,
                isLoading: true,
            }
        case "SET_PRODUCT_LIST_DATA":
            return {
                ...state,
                data: action.payload,
                isLoading: false,
            }
        case "SET_PRODUCT_LIST_ERROR":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            }
        default:
            return state
    }
}